import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Dashboard from "@/pages/Dashboard";
import AdminConsole from "@/pages/AdminConsole";
import RealtimeConsole from "@/pages/RealtimeConsole";
import Demo from "@/pages/Demo";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<AdminConsole />} />
          <Route path="/recording" element={<Dashboard />} />
          <Route path="/realtime" element={<RealtimeConsole />} />
          <Route path="/demo" element={<Demo />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;